// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.landing-wrapper[data-v-6c480f1a] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  min-height: 100%;\n  padding-top: 60px;\n}\n@media (max-width: 1024px) {\n.landing-wrapper[data-v-6c480f1a] {\n    padding-top: 45px;\n}\n}\n", ""]);
// Exports
module.exports = exports;
